module.exports = __webpack_public_path__ + "img/kn.16bcad63.png";